import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Icon } from '@livable/saas-react-components';
import { Chip, TableCell, TableRow } from '@mui/material';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { BalanceStatus } from 'src/components/general/BalanceStatus';
import RippleEffect from 'src/components/general/RippleEffect';
import BillingOptOutCell from 'src/components/property/ResidenciesDataGrid/BillingOptOutCell';
import { ResidentCell } from 'src/components/property/ResidenciesDataGrid/ResidentCell';
import FormerResidentMenu from 'src/pages/ResidentsPage/FormerResidentMenu';
import useStyles from './styles';
import { isValueNumber } from 'src/utils/typeValidators';
export default function FormerResidentTableRow(props) {
  var _row$accountData, _row$accountData2, _row$accountData3;
  const classes = useStyles();
  const isFinalStatementEstimationEnabled = props.isFinalStatementEstimationEnabled,
    openResidentModal = props.openResidentModal,
    propertyId = props.propertyId,
    propertyUtilities = props.propertyUtilities,
    _props$row = props.row,
    row = _props$row === void 0 ? {} : _props$row,
    setFSEBillModalData = props.setFSEBillModalData;
  const handleClick = tab => {
    setFSEBillModalData({
      accountId: row.accountId,
      residencyId: row.residencyId,
      residencyName: row.fullname,
      unitName: row.unitName
    });
    openResidentModal(tab);
  };
  const Cell = _ref => {
    let disabled = _ref.disabled,
      field = _ref.field,
      showCurrency = _ref.showCurrency;
    return /*#__PURE__*/React.createElement(React.Fragment, null, row.vacant ? /*#__PURE__*/React.createElement("span", {
      className: classes.disabledCellText
    }, "N/A") : /*#__PURE__*/React.createElement(RippleEffect, {
      className: "".concat(disabled ? classes.disabledCellText : classes.cellContent, " cellContent")
    }, showCurrency ? "$".concat(field.toFixed(2)) : field));
  };

  // const isDisabled = () => `${row.status === 3 ? classes.disabledClick : ''}`;
  const isDisabled = () => false;
  const getBillingOptIds = (arr1, arr2) => {
    const unique1 = arr1.map(u => u.utilityId).filter(u => arr2.indexOf(u.utilityId) === -1);
    const unique2 = arr2.map(u => u.utilityId).filter(u => arr1.indexOf(u) === -1);
    return unique1.concat(unique2);
  };
  const arr = getBillingOptIds(row.residencyUtilityOptOuts, row.unitUtilityOptOuts);
  return /*#__PURE__*/React.createElement(TableRow, {
    className: classes.formerTableRow
  }, /*#__PURE__*/React.createElement(TableCell, {
    className: "".concat(classes.xsCell, " ").concat(classes.checkboxCell)
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "checkbox-deselect"
  })), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    className: "".concat(isDisabled(), " ").concat(classes.smCell),
    onClick: () => handleClick('overview')
  }, /*#__PURE__*/React.createElement(Cell, {
    field: row.unitName,
    row: row
  })), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.smCell
  }, /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "lock-locked"
    }),
    size: "big",
    variant: !!(row !== null && row !== void 0 && (_row$accountData = row.accountData) !== null && _row$accountData !== void 0 && _row$accountData.portalAccessDateOnly) ? 'successIcon' : 'inactiveIcon'
  })), /*#__PURE__*/React.createElement(TableCell, {
    className: "".concat(isDisabled(), " ").concat(classes.residentCell, " ").concat(classes.cellRight),
    onClick: () => handleClick('overview')
  }, /*#__PURE__*/React.createElement(ResidentCell, {
    handleClick: handleClick,
    isFormer: true,
    params: {
      row: _objectSpread(_objectSpread({}, row), {}, {
        Fullname: (row === null || row === void 0 || (_row$accountData2 = row.accountData) === null || _row$accountData2 === void 0 ? void 0 : _row$accountData2.firstName) + ' ' + (row === null || row === void 0 || (_row$accountData3 = row.accountData) === null || _row$accountData3 === void 0 ? void 0 : _row$accountData3.lastName)
      })
    },
    propertyId: propertyId
  })), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    className: "".concat(isDisabled(), " ").concat(classes.lgCell, " ").concat(classes.cellRight),
    onClick: () => handleClick('overview')
  }, /*#__PURE__*/React.createElement(Cell, {
    field: moment(row.enrolledDateOnly).format('MM/DD/YYYY'),
    row: row
  })), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    className: "".concat(isDisabled(), " ").concat(classes.lgCell, " ").concat(classes.cellRight),
    onClick: () => handleClick('move-out')
  }, /*#__PURE__*/React.createElement(Cell, {
    field: moment(row.moveOutDateOnly).format('MM/DD/YYYY'),
    row: row
  })), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    className: "".concat(isDisabled(), " ").concat(classes.mdCell, " ").concat(classes.cellRight),
    onClick: () => handleClick('livable-solution')
  }, /*#__PURE__*/React.createElement(Cell, {
    field: row.occupancy,
    row: row
  })), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    className: "".concat(isDisabled(), " ").concat(classes.mdCell, " ").concat(classes.cellRight),
    onClick: () => handleClick('billing-settings')
  }, /*#__PURE__*/React.createElement(BillingOptOutCell, {
    params: {
      row: {
        billingOptIds: arr
      }
    },
    propertyUtilities: propertyUtilities
  })), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    className: "".concat(isDisabled(), " ").concat(classes.mdCell, " ").concat(classes.cellRight),
    onClick: () => handleClick('overview')
  }, isValueNumber(row.lastStatement) ? /*#__PURE__*/React.createElement(Cell, {
    field: row.lastStatement,
    row: row,
    showCurrency: true
  }) : /*#__PURE__*/React.createElement("span", {
    className: classes.greyText
  }, "N/A")), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    className: "".concat(isDisabled(), " ").concat(classes.mdCell, " ").concat(classes.cellRight),
    onClick: () => handleClick('overview')
  }, isValueNumber(row.averageStatement) ? /*#__PURE__*/React.createElement(Cell, {
    field: row.averageStatement,
    row: row,
    showCurrency: true
  }) : /*#__PURE__*/React.createElement("span", {
    className: classes.greyText
  }, "N/A")), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    className: "".concat(isDisabled(), " ").concat(classes.mdCell),
    onClick: () => handleClick('overview')
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(isDisabled(), " ").concat(classes.balanceCell, " ").concat(classes.cellContent, " ").concat(classes.cellRight)
  }, row.currentBalance ? "$".concat(row.currentBalance) : /*#__PURE__*/React.createElement("span", {
    className: classes.greyText
  }, "N/A"), row.currentBalance <= 0 && /*#__PURE__*/React.createElement(BalanceStatus, {
    status: "ok",
    hideText: true
  }), row.currentBalance > 0 && /*#__PURE__*/React.createElement(BalanceStatus, {
    status: "critical",
    hideText: true
  }))), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    className: classes.lgCell
  }, /*#__PURE__*/React.createElement(FormerResidentMenu, {
    isFinalStatementEstimationEnabled: isFinalStatementEstimationEnabled,
    openResidentModal: openResidentModal,
    row: row,
    propertyIdExt: propertyId
  })));
}
FormerResidentTableRow.propTypes = {
  row: PropTypes.shape({
    tenant: PropTypes.string,
    enrolledDateOnly: PropTypes.string,
    moveOutDateOnly: PropTypes.string,
    occupancy: PropTypes.number,
    lastStatement: PropTypes.string,
    averageStatement: PropTypes.string,
    balance: PropTypes.string
  })
};